import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FaqAccordion, { buildFaqPageSchema } from "@/components/feature/FaqAccordion";
import Seo from "@/components/feature/Seo";
import { brand } from "@/mocks/siteData";
import { useKonaseemaGuide } from "@/hooks/usePublicGuide";
import { usePublicFaqs } from "@/hooks/usePublicContent";
import { konaseemaFaqs } from "./konaseemaFaqs";
import KonaseemaHero from "./components/KonaseemaHero";
import KonaseemaGalleryBand from "./components/KonaseemaGalleryBand";
import KonaseemaGallerySection from "./components/KonaseemaGallerySection";
import KonaseemaActivities from "./components/KonaseemaActivities";
import KonaseemaSeasons from "./components/KonaseemaSeasons";
import KonaseemaMapAndReach from "./components/KonaseemaMapAndReach";
import KonaseemaCta from "./components/KonaseemaCta";

export default function Konaseema() {
  const faqs = usePublicFaqs("Konaseema", konaseemaFaqs);
  const { gallery } = useKonaseemaGuide();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Seo
        title={`Konaseema Travel Guide — Backwaters & Farms | ${brand.name}`}
        description="Plan a trip to Konaseema, the green Godavari delta of Andhra Pradesh — backwaters, coconut groves, paddy fields, the best season and how to reach."
        path="/konaseema"
        keywords="Konaseema travel guide, Konaseema tourism, things to do in Konaseema, Konaseema backwaters, when to visit Konaseema, how to reach Konaseema"
        image={gallery[0]?.src || "https://readdy.ai/api/search-image?query=Golden%20hour%20view%20over%20the%20Godavari%20delta%20backwaters%20in%20Konaseema%20Andhra%20Pradesh%2C%20coconut%20palms%20and%20green%20paddy%20fields%20reflecting%20warm%20sunset%20light%2C%20cinematic%20wide%20landscape%2C%20rich%20saturated%20green%20and%20amber%20tones%2C%20ultra%20detailed&width=1200&height=630&seq=konaseema-og-fallback&orientation=landscape"}
        structuredData={buildFaqPageSchema(faqs)}
      />
      <Navbar />
      <main>
        <KonaseemaHero />
        <KonaseemaGalleryBand />
        <KonaseemaGallerySection />
        <KonaseemaActivities />
        <KonaseemaSeasons />
        <KonaseemaMapAndReach />
        <FaqAccordion
          faqs={faqs}
          eyebrow="Plan Your Trip"
          title="Konaseema Travel FAQs"
          intro="The questions travellers ask most before visiting the Konaseema delta — where it is, the best season, how to get here and what to do."
        />
        <KonaseemaCta />
      </main>
      <Footer />
    </div>
  );
}